import { Component, Input } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MasterDetailListEntry } from '@sdbn/common';
import { AttributeValue, DocumentTemplateDetails, SelectDefinition, SelectOption } from '../../document-template-administration-model';

@Component({
  selector: 'app-template-lookup-field-editor',
  templateUrl: './template-lookup-field-editor.component.html',
  styleUrls: ['./template-lookup-field-editor.component.scss']
})
export class TemplateLookupFieldsEditorComponent {

  @Input() template: DocumentTemplateDetails;

  selectDefinition: SelectDefinition;
  selectedOption: SelectOption;

  selectedAttribute: AttributeValue

  @Input("selectDefinition") set setSelectDefinition(value: SelectDefinition) {
    this.selectDefinition = value;
    if (value.options.length > 0) {
      this.onSelectionChanged(this.selectedOption = value.options[0]);
    } else {
      this.onSelectionChanged(null);
    }
  }

  optionDetailsFormGroup: FormGroup;
  attributeValueDetailsFormGroup: FormGroup;

  constructor() {

    this.optionDetailsFormGroup = new FormGroup({
      identifier: new FormControl('', [Validators.required]),
    });

    this.optionDetailsFormGroup.valueChanges.subscribe(
      v => {
        if (this.selectedOption != null && this.optionDetailsFormGroup.dirty) {
          this.selectedOption.value = this.optionDetailsFormGroup.controls.identifier.value;
          this.template.dirty = true;
          this.template.validate();
        }
      }
    );

    this.attributeValueDetailsFormGroup = new FormGroup({
      key: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required])
    });

    this.attributeValueDetailsFormGroup.valueChanges.subscribe(
      v => {
        if (this.selectedAttribute != null && this.attributeValueDetailsFormGroup.dirty) {
          this.selectedAttribute.key = this.attributeValueDetailsFormGroup.controls.key.value;
          this.selectedAttribute.value = this.attributeValueDetailsFormGroup.controls.value.value;
          this.template.dirty = true;
          this.template.validate();
        }
      }
    );
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.selectedOption = entry as SelectOption;

    const values = {
      identifier: this.selectedOption != null ? this.selectedOption.value : null,
    };
    this.optionDetailsFormGroup.reset(values);

  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {
    let selectOption = new SelectOption();
    this.selectDefinition.options.push(selectOption);
    this.onSelectionChanged(selectOption);
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    var index = this.selectDefinition.options.indexOf(entry as SelectOption, 0);
    if (index > -1) {
      this.selectDefinition.options.splice(index, 1);
    }
    index = index == 0 ? 0 : index - 1;
    if (this.selectDefinition.options.length > 0) {
      this.onSelectionChanged(this.selectDefinition.options[index]);
    } else {
      this.onSelectionChanged(null);
    }
    this.template.dirty = true;
    this.template.validate();
  }

  selectAttribute(value: AttributeValue) {
    this.selectedAttribute = value;

    const values = {
      key: this.selectedAttribute != null ? this.selectedAttribute.key : null,
      value: this.selectedAttribute != null ? this.selectedAttribute.value : null
    };
    this.attributeValueDetailsFormGroup.reset(values);
  }

  deleteAttribute(value: AttributeValue) {
    const index = this.selectedOption.attributeValues.indexOf(value, 0);
    if (index > -1) {
      this.selectedOption.attributeValues.splice(index, 1);
    }
    this.template.dirty = true;
    this.template.validate();
  }

  addAttribute() {
    let attribute = new AttributeValue();
    this.selectedOption.attributeValues.push(attribute);
    this.template.dirty = true;
    this.template.validate();
  }

}
